(function() {
	'use strict';

	function FrontPageController($scope, BrowserStorageService) {
		$scope.initFront = function () {
			window.isFront = true;
			$scope.buySellTab = BrowserStorageService.LocalStorage.GetItem('frontPageBuySell') || 'selling';

			if ($scope.searchTab === null) {
				$scope.searchTab = window.innerWidth > 768 ? '' : undefined;
			}
		};

		$scope.setBuySellTab = function (tabName) {
			BrowserStorageService.LocalStorage.SetItem('frontPageBuySell', tabName);
			$scope.buySellTab = tabName;
		};

		$scope.setSearchTab = function (tabName) {
			BrowserStorageService.LocalStorage.SetItem('frontPageSearchTab', tabName);
			$scope.searchTab = tabName;
		};

		$scope.slickBreakpoints = [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		];
	}

	FrontPageController.$inject = ['$scope', 'BrowserStorageService'];

	angular.module('KimaMain').controller('FrontPageController', FrontPageController);
})();